export const generateQueryHistoryViewTitle = (historyPath: string) => {
    switch (historyPath) {
        case 'allquery':
            return 'All Queries'
        case 'mysavedquery':
            return 'My Saved Queries'
        case 'queryprogress':
        case 'query-builder-progress':
            return 'Query Progress List'
        case 'cohort-analyser-progress':
            return 'Cohort Analyser Progress List'
        case 'favouritequery':
            return 'Favourite Queries'
        case 'companyquery':
            return 'My Company Query History'
        default:
            return ''
    }
}